import React, { useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import css from './ProjectBriefBanner.module.css';

const ProjectBriefBanner = ({ isComplete, hasPlanningRef }) => {
  const history = useHistory();
  const [hovered, setHovered] = useState(false);
  const hideTimer = useRef(null);

  const handleMouseEnter = () => {
    clearTimeout(hideTimer.current);
    setHovered(true);
  };

  const handleMouseLeave = () => {
    hideTimer.current = setTimeout(() => setHovered(false), 300);
  };

  const handleClick = () => {
    history.push('/your-dream-home/plot-details');
  };

  return (
    <div
      className={css.badge}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <span className={css.dot} />
      <span className={css.label}>
        {isComplete ? 'Edit your project brief' : 'Complete your project brief'}
      </span>

      {hovered && (
        <div
          className={css.tooltip}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <p className={css.tooltipText}>
            {!isComplete
              ? 'Help us match you with the right suppliers by finishing your project details.'
              : !hasPlanningRef
              ? "You haven't added your Planning Reference Number yet. Add it to get matched with the right suppliers."
              : 'Update your project details or make changes to your brief.'}
          </p>
          <button type="button" className={css.tooltipBtn} onClick={handleClick}>
            {isComplete ? 'Edit My Brief →' : 'Complete My Brief →'}
          </button>
        </div>
      )}
    </div>
  );
};

export default ProjectBriefBanner;
